<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Receipt Layout Setup</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="accent" to="/create-receipt-row"><v-icon left>mdi-plus</v-icon>Add Row</v-btn>
      </v-toolbar>
      <v-card-text>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="6">
            <div>
              <span style="font-weight: bold; font-size: 20px;">Header Rows</span>
            </div>
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="topHeaders" :items="receiptHeaders" :search="search"
              :mobile-breakpoint="zeroValue">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="primary" text icon @click="openEditModal(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" text icon @click="openDeleteModal(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <div>
              <span style="font-weight: bold; font-size: 20px;">Footer Rows</span>
            </div>
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="bottomHeaders" :items="receiptFooters" :search="search"
              :mobile-breakpoint="zeroValue">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="primary" text icon @click="openEditModal(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" text icon @click="openDeleteModal(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>



    <!-- edit dialog modal-->
    <v-dialog v-model="editDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Edit Receipt Row</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form ref="editForm" v-model="validEdit">
              <v-row class="text--primary subtitle-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.rowText"
                    label="Row Text"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model.number="editedItem.fontSize"
                    label="Font Size"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editedItem.alignment"
                    :items="alignmentOptions"
                    label="Alignment"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="editedItem.isBold"
                    label="Bold"
                    dense
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" :loading="loader" :disabled="!validEdit" @click="updateItem">Save Changes</v-btn>
                  <v-btn text @click="editDialog = false">Cancel</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- delete dialog modal-->
    <v-dialog v-model="deleteDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="red" dark>
          <v-toolbar-title> Delete Item </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="text--primary subtitle-2">
              <v-col cols="12">
                Are you sure you want to delete this item?
              </v-col>
              <v-col cols="12">
                <span style="font-size: 20px">{{ selectedItem.rowText }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="red" dark :loading="loader" @click="deleteItem">Yes, Delete</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    selectedItem: {},
    deleteDialog: false,
    editDialog: false,
    validEdit: false,
    editedItem: {
      rowText: "",
      fontSize: 12,
      alignment: "left",
      isBold: false
    },
    alignmentOptions: ["left", "center", "right"],
    rules: {
      required: v => !!v || "Field is required"
    },
    zeroValue: 0,
    pageItems: 100,
    date: null,
    receiptHeaders: [],
    receiptFooters: [],
    topHeaders: [
      { text: "Title", value: "rowText" },
      { text: "Action", value: "action" }
    ],
    bottomHeaders: [
      { text: "Title", value: "rowText" },
      { text: "Action", value: "action" }
    ],
    currencies: [],
    excelFile: null,
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    openEditModal(data) {
      this.editedItem = { ...data };
      this.editDialog = true;
    },
    updateItem() {
      if (!this.$refs.editForm.validate()) {
        return;
      }
      const url = `/receipt-row/${this.editedItem.id}`;
      const payload = {
        ...this.editedItem,
        fontSize: this.editedItem.fontSize || 0
      };
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("put", { url, data: payload })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.editDialog = false;
            self.getReceiptHeaders();
            self.getReceiptFooters();
            self.$refs.snackbar.show("Updated successfully", "green");
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    openDeleteModal(data) {
      this.selectedItem = data;
      this.deleteDialog = true;
    },
    deleteItem() {
      const url = `/receipt-row/${this.selectedItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.deleteDialog = false;
            self.getReceiptHeaders();
            self.getReceiptFooters();
            self.$refs.snackbar.show("Deleted successfully", "green");
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    getReceiptHeaders() {
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-headers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptHeaders = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReceiptFooters() {
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-footers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptFooters = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getReceiptHeaders();
    this.getReceiptFooters();
  },
};
</script>